import options from './thing-name.component';

export default {
    selector: 'dtAsThingName',
    options
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/search/advanced/thing-name/index.js